import SvgIcon from "./LabLogoImported.svg?react";

export const LabLogoImportedIcon = SvgIcon;
